import axios from 'axios'

import { URL_PREFIX } from '../config'

export const getAllArtworkConfigs = (artist, page = 1, pageSize = 10000) => {
  const params = {
    artist_id: artist,
    page: page,
    page_size: pageSize
  }
  return axios.get(URL_PREFIX + '/artwork-configs/', {
    params
  })
}

export const getArtworkConfig = (artwork, cancelToken=null) => {
  return axios.get(URL_PREFIX + '/artwork-configs/' + artwork, {
      cancelToken: cancelToken?.token
  })
}

export const patchArtworkConfig = (artwork, params) => {
  return axios.patch(URL_PREFIX + '/artwork-configs/' + artwork + '/', params)
}

export const postArtworkConfig = (param) => {
  return axios.post(URL_PREFIX + '/artwork-configs/', {
    is_from_signup: true,
    is_for_sale: true,
    has_watermark: true,
    watermark_s3_url: 'test',
    gallery_ranking_weight: 0,
    profile_ranking_weight: 0,
    ...param
  })
}

export const putArtworkConfig = (id, param) => {
  return axios.put(URL_PREFIX + '/artwork-configs/' + id + '/', {
    is_from_signup: true,
    is_for_sale: true,
    has_watermark: true,
    watermark_s3_url: 'test',
    gallery_ranking_weight: 0,
    profile_ranking_weight: 0,
    ...param
  })
}

export const deleteArtworkConfig = (id) => {
  return axios.delete(URL_PREFIX + '/artwork-configs/' + id + '/')
}
